"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntitySidebarGroup = exports.EntitySidebarGroupDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var sidebar_group_header_1 = require("../app/sidebar-group-header");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var entity_sidebar_details_link_1 = require("./entity-sidebar-details-link");
exports.EntitySidebarGroupDefaultProps = {
  items: []
};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var HeaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    transition: all 0s;\n    /* ", ";\n    padding-top: ", "; */\n\n    &:hover {\n      /* color: ", "; */\n    }\n  "], ["\n    transition: all 0s;\n    /* ", ";\n    padding-top: ", "; */\n\n    &:hover {\n      /* color: ", "; */\n    }\n  "])), theme_1.theme.H_DOT_BG(), theme_1.theme.UNIT(3, 2), theme_1.theme.COLOR('primary'))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ItemStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Header: (0, styled_components_1.default)(sidebar_group_header_1.SidebarGroupHeader)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Body: styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Item: (0, styled_components_1.default)(entity_sidebar_details_link_1.EntitySidebarDetailsLink)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles)
};
var EntitySidebarGroup = function (props) {
  var className = props.className,
    entityTypeName = props.entityTypeName,
    children = props.children,
    isOpen = props.isOpen,
    items = props.items,
    label = props.label,
    onToggle = props.onToggle;
  var definition = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName);
  var showBody = isOpen;
  var showItems = isOpen && !!items.length;
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.Header, {
    onClick: onToggle,
    isOpen: isOpen
  }, label || definition.pluralLabel), showBody && react_1.default.createElement(My.Body, null, children, showItems && items.map(function (item, index) {
    return react_1.default.createElement(My.Item, {
      hasIcon: false,
      key: item.id,
      entity: item
    });
  })));
};
exports.EntitySidebarGroup = EntitySidebarGroup;
exports.EntitySidebarGroup.defaultProps = exports.EntitySidebarGroupDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;